import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=a86d8df2&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"
import style0 from "./Element.vue?vue&type=style&index=0&id=a86d8df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86d8df2",
  null
  
)

export default component.exports